import siteConfig from "../site-config";

export const hasLocalSchemasEnabled = () => {
    const isLocalSchemasFlagEnabled =
        siteConfig.LOCAL_SCHEMAS_ENABLED === "true" && process.env.NODE_ENV === "development";

    return isLocalSchemasFlagEnabled;
};
